var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 32.1393V0.800003H16.5027L16.861 1.16161L24.0263 8.39375L24.3846 8.75536V12.8536H21.9962V10.4429H14.8308V3.21072H2.88846V29.7286H19.6077V32.1393H0.5Z",
    fill: "#0C7488"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27692 15.2643V12.8536H19.6077V15.2643H5.27692Z",
    fill: "#0C7488"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27692 21.2911V18.8804H13.6365V21.2911H5.27692Z",
    fill: "#0C7488"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.025 21.2911V18.8804H19.6077V21.2911H16.025Z",
    fill: "#0C7488"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27692 26.1125V23.7018H13.6365V26.1125H5.27692Z",
    fill: "#0C7488"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.025 26.1125V23.7018H19.6077V26.1125H16.025Z",
    fill: "#0C7488"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 25,
    r: 9,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7563 28.4615H20.1133V21.6963H18.7563V28.4615Z",
    fill: "#0C7488"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8833 21.6866V26.3389L22.8108 21.6866H21.4539V28.4615H22.8108V23.8189L25.8833 28.4615H27.2402V21.6866H25.8833Z",
    fill: "#0C7488"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceMenuIcon);
export default __webpack_public_path__ + "static/media/invoice-menu-icon.7838cc2d2622aa31fb4148f1be854090.svg";
export { ForwardRef as ReactComponent };